import React from 'react'
import Footer from '../../Footer/Footer'
import ContactBanner from './ContactBanner'
import ContactMain from './ContactMain'
import '../innerpage.css'



const StudyinUsa = () => {
  return (
    <>
        <ContactBanner></ContactBanner>
        <ContactMain></ContactMain>
        <Footer></Footer>
    </>
  )
}

export default StudyinUsa